import * as api from "./api";

export function getVersion(): JQueryPromise<string>
{
    return api.get<string>({
        endpoint: "api/appinfo/version"
    });
}

export function getRelease(): JQueryPromise<string>
{
    return api.get<string>({
        endpoint: "api/appinfo/version?release=true"
    });
}

export function getServerVersion(): Promise<string>
{
    return api.getServer<string>({
        endpoint: "/api/appinfo/version"
    });
}